var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxExcitementThrill01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-excitement-thrill-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,11v2H18.79l-1.92,7.85a2,2,0,0,1-3.74,0l0-.11L11,12.24,9,3.88,6.79,13H2V11H5.21L7.13,3.15a2,2,0,0,1,3.74,0l0,.11L13,11.76l2,8.36L17.21,11Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxExcitementThrill01);
export default __webpack_public_path__ + "static/media/24px-excitement-thrill-01.f2ef5517d71c61e678c3140e5270a58d.svg";
export { ForwardRef as ReactComponent };